<div class="panel-top">
  <div class="headline-section">
    <h2 class="page-title">
      <ng-content select="[headline]"></ng-content>
    </h2>
    <p class="page-subtitle">
      <ng-content select="[subtitle]"></ng-content>
    </p>
  </div>
  <div class="action-items">
    <ng-content select="[action-items]"></ng-content>
  </div>
</div>
